export default __webpack_public_path__ + "static/header-diagnostics-05460c9d355c8d19b30d5e26d256e7bc.jpg";